/*
  Entwurf D: Bewertungsliste (sections/kaufbox-d-review-list.liquid).

  Nur Bewertungen in der Sprache der Seite, erst „Bewertungen je Schritt“ (5),
  dann je 5 weitere per „Mehr laden“. Sprache einer Bewertung: Judge.me-Feld
  „language“; fehlt es, eine einfache Wort-Erkennung (DE/FR/EN), sonst die
  Shop-Hauptsprache laut Judge.me. Gibt es in der Sprache der Seite keine
  Bewertung, kommen alle (erst Hauptsprache, dann übrige Sprachen).

  Daten: dieselbe öffentliche Judge.me-Schnittstelle, die das Judge.me-Widget
  auf der Seite abfragt (cdn.judge.me, 10 Bewertungen je Seite, CDN-Cache).
  Steht die Liste, blendet die Klasse „kbd-rl-on“ am <html> die Liste des
  Judge.me-Widgets aus (assets/kaufbox-d.css); Siegel, Verteilung und
  „Bewertung schreiben“ bleiben. Klappt das Laden nicht, bleibt alles wie
  bisher (Judge.me-Liste sichtbar, diese Section leer).

  Übersetzen: Ist eine Bewertung in einer anderen Sprache als die Seite,
  bekommt sie den Link „Übersetzen“/„Traduire“/„Translate“. Ein Klick holt die
  Übersetzung von derselben Judge.me-Schnittstelle, die der Übersetzen-Link
  des Judge.me-Widgets nutzt (api.judge.me/api/review_translations, ohne
  Schlüssel), und tauscht Titel und Text; danach heißt der Link „Original
  anzeigen“ (hin und her, je Bewertung nur einmal geladen). Klappt es nicht,
  bleibt das Original und der Link verschwindet bei dieser Bewertung.
*/
(function () {
  if (window.__kbdReviewList) return;
  window.__kbdReviewList = true;

  var API = 'https://cdn.judge.me/reviews/all_reviews_js_based';
  var TR_API = 'https://api.judge.me/api/review_translations';
  var TIMEOUT = 10000;

  // Häufige Wörter je Sprache – nur für Bewertungen ohne Judge.me-Sprache.
  var WORDS = {
    de: 'der die das und ist nicht sehr ich wir mit für auf ein eine einen dem den zu von sind auch gut gute guter toll tolle toller klasse danke stuhl stühle stuhle qualität lieferung leistung preis alles schnell schön bequem hochwertig hochwertige zufrieden geliefert erwartet wie',
    fr: 'le la les et est très une un des pour avec pas je nous chaise chaises qualité livraison merci bien parfait rapide belle beau produit conforme du au sont vraiment confortable',
    en: 'the and is very great chair chairs quality delivery with for not we good thank thanks love fast nice product recommend comfortable was are of to it'
  };
  var LEX = {};
  Object.keys(WORDS).forEach(function (l) {
    WORDS[l].split(' ').forEach(function (w) { (LEX[w] = LEX[w] || []).push(l); });
  });
  function guessLang(text) {
    var s = String(text || '').toLowerCase();
    var score = { de: 0, fr: 0, en: 0 };
    score.de += (s.match(/[äöüß]/g) || []).length * 2;
    score.fr += (s.match(/[éèêàçœ]/g) || []).length * 2;
    (s.match(/[a-zàâçéèêëîïôûùüÿæœäöß]+/g) || []).forEach(function (w) {
      (LEX[w] || []).forEach(function (l) { score[l] += 1; });
    });
    var best = '', max = 0, tie = false;
    Object.keys(score).forEach(function (l) {
      if (score[l] > max) { best = l; max = score[l]; tie = false; } else if (score[l] === max && max > 0) { tie = true; }
    });
    return max > 0 && !tie ? best : '';
  }
  function baseLang(code) { return String(code || '').toLowerCase().split(/[-_]/)[0]; }

  function fmt(str, vals) {
    return String(str).replace(/\{(\w+)\}/g, function (m, k) { return vals[k] != null ? vals[k] : m; });
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function decode(str) {
    var t = document.createElement('textarea');
    t.innerHTML = String(str || '');
    return t.value;
  }
  function query(q) {
    return Object.keys(q).map(function (k) { return encodeURIComponent(k) + '=' + encodeURIComponent(q[k]); }).join('&');
  }
  function getJson(url) {
    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, TIMEOUT) : null;
    return fetch(url, { credentials: 'omit', signal: ctrl ? ctrl.signal : undefined }).then(function (res) {
      if (timer) clearTimeout(timer);
      if (!res.ok) throw new Error('Judge.me ' + res.status);
      return res.json();
    }, function (err) {
      if (timer) clearTimeout(timer);
      throw err;
    });
  }
  function htmlToText(html) {
    var d = document.createElement('div');
    d.innerHTML = String(html || '').replace(/<br\s*\/?>/gi, '\n').replace(/<\/p>\s*<p[^>]*>/gi, '\n\n');
    return (d.textContent || '').trim();
  }

  function init() {
    var root = document.querySelector('[data-kbd-rl]');
    if (!root || root.__kbdRl) return;
    root.__kbdRl = true;
    var list = root.querySelector('[data-kbd-rl-list]');
    var more = root.querySelector('[data-kbd-rl-more]');
    if (!list || !more || !window.fetch || !window.Promise) return;

    var shop = root.getAttribute('data-shop');
    var lang = baseLang(root.getAttribute('data-lang') || document.documentElement.lang) || 'de';
    var rootUrl = root.getAttribute('data-root') || '/';
    var perPage = parseInt(root.getAttribute('data-per-page'), 10) || 5;
    var locale = document.documentElement.lang || lang;

    var T = { verified: 'Verifizierter Kauf', product: 'Bewertet: {title}', reply: 'Antwort von {name}', stars: '{n} von 5 Sternen', photo: 'Foto öffnen', translate: 'Übersetzen', original: 'Original anzeigen', translating: 'Wird übersetzt …' };
    var i18n = root.querySelector('script[data-kbd-rl-i18n]');
    if (i18n) {
      try {
        var data = JSON.parse(i18n.textContent);
        var dec = document.createElement('textarea');
        Object.keys(T).forEach(function (k) {
          if (typeof data[k] !== 'string' || !data[k]) return;
          dec.innerHTML = data[k];
          T[k] = dec.value;
        });
      } catch (e) { /* deutsche Texte bleiben */ }
    }

    var shopLang = 'de';   // wird aus der ersten Antwort übernommen (Judge.me „primary_language“)
    var seen = {};
    var queue = [];
    var streams = [];
    var shown = 0;
    var langMatches = 0;
    var fallback = false;

    function get(params) {
      var q = {
        widget_type: 'all-reviews-widget-v2025',
        review_type: 'all-reviews',
        sort_by: 'created_at',
        sort_dir: 'desc',
        translation_locale: lang,
        widget_theme: 'align',
        shop_domain: shop,
        platform: 'shopify'
      };
      Object.keys(params).forEach(function (k) { q[k] = params[k]; });
      return getJson(API + '?' + query(q));
    }

    function reviewText(r) { return (r.title || '') + ' ' + (r.body || htmlToText(r.body_html)); }
    function reviewLang(r) {
      var l = baseLang(r.language);
      if (l) return l;
      return guessLang(reviewText(r)) || shopLang;
    }
    // Übersetzen-Link nur, wenn die Bewertung nicht in der Sprache der Seite
    // ist. Die Wort-Erkennung hat das letzte Wort, weil Judge.me kurze
    // deutsche Texte manchmal falsch einordnet („Tolle Qualität Danke!“ → id).
    function isForeign(r) {
      if (reviewLang(r) === lang) return false;
      return guessLang(reviewText(r)) !== lang;
    }

    // Übersetzung je Bewertung höchstens einmal laden (auch über „Mehr laden“ hinweg).
    var translations = {};
    function translation(r) {
      if (!translations[r.uuid]) {
        translations[r.uuid] = getJson(TR_API + '?' + query({
          review_uuids: r.uuid,
          language: lang,
          page: '-1',
          shop_domain: shop,
          platform: 'shopify'
        })).then(function (d) {
          var x = d && d[r.uuid];
          if (!x || typeof x !== 'object') throw new Error('Judge.me: keine Übersetzung');
          function part(p) { return p && p.success && p.translated_text ? decode(p.translated_text).trim() : ''; }
          return { title: part(x.title), body: part(x.body) };
        });
      }
      return translations[r.uuid];
    }
    var TR_ICON = '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M2 4.75h8.5M6.25 3v1.75M8.6 4.75c-.6 2.9-2.4 5.3-5.1 6.9M4.6 7.4c.9 1.6 2.2 2.9 3.9 3.8M10.5 17l3.25-8 3.25 8M11.6 14.4h4.3" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    function translateControl(r, li, titleEl, bodyEl) {
      var orig = { title: titleEl ? titleEl.textContent : '', body: bodyEl ? bodyEl.textContent : '' };
      var wrap = el('p', 'kbd-rl-tr');
      var btn = el('button', 'kbd-rl-tr-btn');
      btn.type = 'button';
      btn.innerHTML = TR_ICON;
      var label = el('span', '', T.translate);
      btn.appendChild(label);
      wrap.appendChild(btn);
      var showing = false;
      function show(t) {
        if (titleEl) titleEl.textContent = t.title || orig.title;
        if (bodyEl) bodyEl.textContent = t.body || orig.body;
      }
      function fail() {
        show(orig);
        var hadFocus = document.activeElement === btn;
        wrap.parentNode && wrap.parentNode.removeChild(wrap);
        if (hadFocus) { try { li.focus({ preventScroll: true }); } catch (e) { li.focus(); } }
      }
      btn.addEventListener('click', function () {
        if (btn.getAttribute('aria-busy') === 'true') return;
        if (showing) {
          show(orig);
          showing = false;
          label.textContent = T.translate;
          return;
        }
        btn.setAttribute('aria-busy', 'true');
        label.textContent = T.translating;
        translation(r).then(function (t) {
          btn.removeAttribute('aria-busy');
          // Ohne Text-Übersetzung (oder ohne Titel bei Bewertungen ohne Text)
          // bzw. wenn sich nichts ändert: Original lassen, Link weg.
          var ok = orig.body ? !!t.body : !!t.title;
          var same = (t.title || orig.title) === orig.title && (t.body || orig.body) === orig.body;
          if (!ok || same) { fail(); return; }
          show(t);
          showing = true;
          label.textContent = T.original;
        }, function () {
          btn.removeAttribute('aria-busy');
          fail();
        });
      });
      return wrap;
    }

    // Eine Folge von Judge.me-Seiten (Hauptsprache bzw. übrige Sprachen).
    function stream(params, pageKey, listKey, pagKey, filter) {
      return { params: params, pageKey: pageKey, listKey: listKey, pagKey: pagKey, filter: filter, page: 0, done: false };
    }
    function pull(s) {
      s.page += 1;
      var p = {};
      Object.keys(s.params).forEach(function (k) { p[k] = s.params[k]; });
      p[s.pageKey] = s.page;
      return get(p).catch(function (err) {
        s.page -= 1;   // dieselbe Seite beim nächsten „Mehr laden“ noch einmal
        throw err;
      }).then(function (d) {
        if (!d || typeof d !== 'object') throw new Error('Judge.me: keine Daten');
        if (d.primary_language) shopLang = baseLang(d.primary_language) || shopLang;
        var items = Array.isArray(d[s.listKey]) ? d[s.listKey] : [];
        var pag = d[s.pagKey] || {};
        var total = parseInt(pag.total_pages, 10) || 0;
        if (!items.length || s.page >= total) s.done = true;
        items.forEach(function (r) {
          if (!r || !r.uuid || seen[r.uuid]) return;
          if (s.filter && !s.filter(r)) return;
          seen[r.uuid] = true;
          queue.push(r);
          if (!fallback) langMatches += 1;
        });
      });
    }
    // Lädt, bis mindestens n Bewertungen bereitliegen oder nichts mehr kommt.
    function fill(n) {
      if (queue.length >= n) return Promise.resolve();
      var s = null;
      for (var i = 0; i < streams.length; i++) { if (!streams[i].done) { s = streams[i]; break; } }
      if (!s) {
        if (!fallback && shown === 0 && langMatches === 0) {
          // Keine Bewertung in der Sprache der Seite: alle zeigen.
          fallback = true;
          streams = [
            stream({ primary_language: shopLang, skip_other_languages: 1 }, 'page', 'primary_language_reviews', 'primary_language_pagination', null),
            stream({ primary_language: shopLang, skip_primary_language: 1 }, 'other_language_page', 'other_language_reviews', 'other_language_pagination', null)
          ];
          return fill(n);
        }
        return Promise.resolve();
      }
      return pull(s).then(function () { return fill(n); });
    }
    var loadFailed = false;
    function hasMore() {
      if (queue.length > 0) return true;
      // Nach einem Ladefehler den Button lassen, solange Judge.me noch Seiten hat.
      return loadFailed && streams.some(function (s) { return !s.done; });
    }

    var STAR = 'M10 1.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8L10 14.9l-5.2 2.7 1-5.8L1.5 7.7l5.9-.9z';
    function starsSvg() {
      var ns = 'http://www.w3.org/2000/svg';
      var svg = document.createElementNS(ns, 'svg');
      svg.setAttribute('viewBox', '0 0 100 20');
      svg.setAttribute('focusable', 'false');
      var g = document.createElementNS(ns, 'g');
      g.setAttribute('fill', 'currentColor');
      for (var i = 0; i < 5; i++) {
        var p = document.createElementNS(ns, 'path');
        p.setAttribute('transform', 'translate(' + (i * 20) + ' 0)');
        p.setAttribute('d', STAR);
        g.appendChild(p);
      }
      svg.appendChild(g);
      return svg;
    }
    function dateText(iso) {
      var d = new Date(iso);
      if (isNaN(d.getTime())) return '';
      try { return new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'long', year: 'numeric' }).format(d); } catch (e) { return d.toLocaleDateString(); }
    }
    function productHref(path) {
      if (!path || path.charAt(0) !== '/' || path.charAt(1) === '/') return '';
      var base = rootUrl.replace(/\/$/, '');
      return (base && path.indexOf(base + '/') !== 0 ? base : '') + path;
    }
    function picUrl(p) {
      if (!p) return '';
      if (typeof p === 'string') return p;
      var u = p.urls || p;
      return u.compact || u.small || u.huge || u.original || '';
    }
    function picFull(p) {
      if (!p) return '';
      if (typeof p === 'string') return p;
      var u = p.urls || p;
      return u.huge || u.original || u.compact || u.small || '';
    }

    function card(r) {
      var li = el('li', 'kbd-rl-item');
      li.setAttribute('tabindex', '-1');
      var rating = Math.max(0, Math.min(5, parseInt(r.rating, 10) || 0));

      var side = el('div', 'kbd-rl-side');
      side.appendChild(el('p', 'kbd-rl-name', r.reviewer_name || ''));
      if (r.verified_buyer) {
        var ver = el('p', 'kbd-rl-ver');
        ver.innerHTML = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M3.5 8.5l3 3 6-7" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        ver.appendChild(document.createTextNode(T.verified));
        side.appendChild(ver);
      }
      li.appendChild(side);

      var main = el('div', 'kbd-rl-main');
      var top = el('div', 'kbd-rl-top');
      var stars = el('span', 'kbd-stars');
      stars.setAttribute('role', 'img');
      stars.setAttribute('aria-label', fmt(T.stars, { n: rating }));
      stars.appendChild(starsSvg());
      var fg = el('span', 'kbd-stars-fg');
      fg.style.width = (rating * 20) + '%';
      fg.appendChild(starsSvg());
      stars.appendChild(fg);
      top.appendChild(stars);
      var dt = dateText(r.created_at);
      if (dt) {
        var time = el('time', 'kbd-rl-date', dt);
        time.setAttribute('datetime', String(r.created_at).slice(0, 10));
        top.appendChild(time);
      }
      main.appendChild(top);

      var titleEl = r.title ? el('h3', 'kbd-rl-title', r.title) : null;
      if (titleEl) main.appendChild(titleEl);
      var body = r.body || htmlToText(r.body_html);
      var bodyEl = body ? el('p', 'kbd-rl-body', body) : null;
      if (bodyEl) main.appendChild(bodyEl);
      if ((titleEl || bodyEl) && isForeign(r)) main.appendChild(translateControl(r, li, titleEl, bodyEl));

      var pics = Array.isArray(r.pictures_urls) ? r.pictures_urls.slice(0, 4) : [];
      if (pics.length) {
        var pw = el('div', 'kbd-rl-pics');
        pics.forEach(function (p) {
          var src = picUrl(p), full = picFull(p);
          if (!src || !/^https:\/\//.test(src)) return;
          var a = el('a', 'kbd-rl-pic');
          a.href = /^https:\/\//.test(full) ? full : src;
          a.target = '_blank';
          a.rel = 'noopener';
          a.setAttribute('aria-label', T.photo);
          var img = el('img');
          img.src = src;
          img.alt = '';
          img.loading = 'lazy';
          img.width = 72;
          img.height = 72;
          a.appendChild(img);
          pw.appendChild(a);
        });
        if (pw.childNodes.length) main.appendChild(pw);
      }

      var title = r.product_title_localized || r.product_title;
      if (!r.is_shop_review && title && r.product_url && r.product_url !== '/') {
        var prod = el('p', 'kbd-rl-prod');
        var parts = String(T.product).split('{title}');
        prod.appendChild(document.createTextNode(parts[0] || ''));
        var href = r.product_in_store !== false ? productHref(r.product_url) : '';
        var link = href ? el('a', '', title) : el('span', '', title);
        if (href) link.href = href;
        prod.appendChild(link);
        if (parts[1]) prod.appendChild(document.createTextNode(parts[1]));
        main.appendChild(prod);
      }

      var reply = r.reply_content ? htmlToText(r.reply_content) : '';
      if (reply) {
        var rw = el('div', 'kbd-rl-reply');
        rw.appendChild(el('p', 'kbd-rl-reply-h', fmt(T.reply, { name: r.shop_reply_name || 'SIX' })));
        rw.appendChild(el('p', 'kbd-rl-reply-b', reply));
        main.appendChild(rw);
      }

      li.appendChild(main);
      return li;
    }

    function render(focusFirst) {
      var batch = queue.splice(0, perPage);
      var first = null;
      batch.forEach(function (r) {
        var c = card(r);
        if (!first) first = c;
        list.appendChild(c);
      });
      shown += batch.length;
      more.hidden = !hasMore();
      if (focusFirst && first) {
        try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); }
      }
      return batch.length;
    }

    function start() {
      streams = [
        stream({ primary_language: lang, skip_other_languages: 1 }, 'page', 'primary_language_reviews', 'primary_language_pagination', function (r) { return reviewLang(r) === lang; })
      ];
      fill(perPage + 1).then(function () {
        if (!render(false)) throw new Error('Judge.me: keine Bewertungen');
        root.classList.add('is-ready');
        root.setAttribute('data-mode', fallback ? 'all' : 'lang');
        document.documentElement.classList.add('kbd-rl-on');
      }).catch(function () {
        root.classList.add('is-failed');
        list.innerHTML = '';
        more.hidden = true;
      });
    }

    more.addEventListener('click', function () {
      if (more.getAttribute('aria-busy') === 'true') return;
      more.setAttribute('aria-busy', 'true');
      more.disabled = true;
      loadFailed = false;
      fill(perPage + 1).catch(function () { loadFailed = true; }).then(function () {
        more.removeAttribute('aria-busy');
        more.disabled = false;
        render(true);
      });
    });

    // Gleich laden (nicht erst beim Hinscrollen): Die Liste soll stehen, bevor
    // jemand dort ankommt – sonst springt die Seite beim Tausch der Listen.
    start();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
